import React, { lazy, Suspense } from "react";
import { Loader } from "@sicredi/react";
import { BrowserRouter as Router, Route, Switch } from "react-router-dom";
import { withOidcSecure } from "@axa-fr/react-oidc-context";

import { PAGE } from "#/constants";

const LazyHome = lazy(() => import("#/containers/Home"));
const LazyNotFound = lazy(() => import("#/containers/NotFound"));
const LazyInitialData = lazy(() => import("#/containers/InitialData"));
const LazyModality = lazy(() => import("#/containers/Modality"));
const LazyOffer = lazy(() => import("#/containers/Offer"));
const LazyDPS_SPOUSE = lazy(() => import("#/containers/Spouse"));
const LazyDPS = lazy(() => import("#/containers/DPS"));
const LazySelectQuestions = lazy(
  () => import("#/containers/DPS/SelectQuestions")
);
const LazyQuestionnarie = lazy(() => import("#/containers/DPS/Questionnarie"));
const LazyComplementaryDataOne = lazy(
  () => import("#/containers/ComplementaryData/One")
);
const LazyComplementaryDataTwo = lazy(
  () => import("#/containers/ComplementaryData/Two")
);
const LazyComplementaryDataThree = lazy(
  () => import("#/containers/ComplementaryData/Three")
);
const LazyBeneficiaries = lazy(() => import("#/containers/Beneficiaries"));
const LazyPayment = lazy(() => import("#/containers/Payment"));
const LazyResume = lazy(() => import("#/containers/Resume"));
const LazyTokenValidation = lazy(() => import("#/containers/TokenValidation/"));
const LazySuccess = lazy(() => import("#/containers/Success"));
const LazyErrorDate = lazy(() => import("#/containers/Errors/Date"));
const LazyErrorAge = lazy(() => import("#/containers/Errors/Age"));
const LazyErrorCellPhone = lazy(() => import("#/containers/Errors/CellPhone"));
const LazyErrorProposal = lazy(() => import("#/containers/Errors/Proposal"));
const LazyContractedInsurance = lazy(
  () => import("#/containers/ContractedInsurance")
);
const LazyCancellation = lazy(() => import("#/containers/Cancellation"));
const LazyCancellationSuccess = lazy(
  () => import("#/containers/Cancellation/Success")
);
const LazySpeakWithManager = lazy(
  () => import("#/containers/SpeakWithManager")
);
const LazyMenu = lazy(() => import("#/containers/Menu"));
const LazyInsuranceDetails = lazy(
  () => import("#/containers/InsuranceDetails")
);
const LazyUsefulPhones = lazy(() => import("#/containers/UsefulPhones"));

export const Routes: React.FC = () => (
  <Router basename={process.env.PUBLIC_URL}>
    <Suspense fallback={<Loader show fullScreen />}>
      <Switch>
        <Route exact path={PAGE.ROOT()} component={LazyHome} />
        <Route exact path={PAGE.MENU()} component={withOidcSecure(LazyMenu)} />
        <Route
          exact
          path={PAGE.INSURANCE_DETAILS()}
          component={LazyInsuranceDetails}
        />
        <Route exact path={PAGE.USEFUL_PHONES()} component={LazyUsefulPhones} />
        <Route exact path={PAGE.MODALITY()} component={LazyModality} />
        <Route
          exact
          path={PAGE.INITIAL_DATA()}
          component={withOidcSecure(LazyInitialData)}
        />
        <Route
          exact
          path={PAGE.SPEAK_MANAGER()}
          component={LazySpeakWithManager}
        />
        <Route exact path={PAGE.OFFER()} component={LazyOffer} />
        <Route exact path={PAGE.SPOUSE_DATA()} component={LazyDPS_SPOUSE} />
        <Route
          exact
          path={PAGE.SELECT_QUESTIONS()}
          component={LazySelectQuestions}
        />
        <Route exact path={PAGE.DPS()} component={LazyDPS} />
        <Route
          exact
          path={PAGE.QUESTIONNARIE()}
          component={LazyQuestionnarie}
        />
        <Route
          exact
          path={PAGE.COMPLEMENTARY_DATA_ONE()}
          component={LazyComplementaryDataOne}
        />
        <Route
          exact
          path={PAGE.COMPLEMENTARY_DATA_TWO()}
          component={LazyComplementaryDataTwo}
        />
        <Route
          exact
          path={PAGE.COMPLEMENTARY_DATA_THREE()}
          component={LazyComplementaryDataThree}
        />
        <Route
          exact
          path={PAGE.BENEFICIARIES()}
          component={LazyBeneficiaries}
        />
        <Route exact path={PAGE.PAYMENT()} component={LazyPayment} />
        <Route exact path={PAGE.RESUME()} component={LazyResume} />
        <Route
          exact
          path={PAGE.TOKEN_VALIDATION(":contractType")}
          component={LazyTokenValidation}
        />
        <Route exact path={PAGE.SUCCESS()} component={LazySuccess} />
        <Route exact path={PAGE.ERROR_DATE()} component={LazyErrorDate} />
        <Route
          exact
          path={PAGE.CONTRACTED_INSURANCE()}
          component={LazyContractedInsurance}
        />
        <Route exact path={PAGE.CANCELLATION()} component={LazyCancellation} />
        <Route
          exact
          path={PAGE.CANCELLATION_SUCCESS()}
          component={LazyCancellationSuccess}
        />
        <Route exact path={PAGE.ERROR_AGE()} component={LazyErrorAge} />
        <Route
          exact
          path={PAGE.ERROR_CELL_PHONE()}
          component={LazyErrorCellPhone}
        />
        <Route
          exact
          path={PAGE.ERROR_PROPOSAL()}
          component={LazyErrorProposal}
        />
        <Route path="*" component={LazyNotFound} />
      </Switch>
    </Suspense>
  </Router>
);
